import {
  ICON_PATHS,
  type IconName,
  THICK_ICONS,
} from '@alternativamais/chat-core';

export type NomeIcone = IconName;

export function Icone({
  nome,
  tamanho = 20,
  className,
  cor,
}: {
  nome: NomeIcone;
  tamanho?: number;
  className?: string;
  /** Cor do traço (cor de cargo, por exemplo). */
  cor?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={tamanho}
      height={tamanho}
      aria-hidden="true"
      className={className}
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: THICK_ICONS.has(nome) ? 3 : 1.8,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        flexShrink: 0,
        ...(cor ? { color: cor } : {}),
      }}
    >
      {ICON_PATHS[nome].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
